import React, { useState } from "react";
import { useNavigate ,useLocation, Link} from "react-router-dom";
import InputField from "../../../../components/Common/InputField"; // Import InputField component
import { Box, Button, styled } from "@mui/material";

import { useResetPasswordMutation } from "../../../../services/authService";
import { toast, ToastContainer } from "react-toastify";

const ResetPasswordForm = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const location = useLocation();
  
  const { email, verificationCode, organization_id } = location.state || {};
  const [resetPassword] = useResetPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const response = await resetPassword({
        email: email,
        verification_code: verificationCode,
        new_password: newPassword,
        organization_id: organization_id,
      });
      console.log(response);
      
      if (response?.error) {
        console.log(response?.error?.message);
        
        const errorMessage = response.error?.message;

        // Show error in toast instead of input field
        if (errorMessage) {
          toast.error(errorMessage);
        } else {
          setError(errorMessage);
        }

        return;
      }

      console.log(response.data);
      toast.success("Password has been reset successfully!");
      navigate("/");
      
    } catch (err) {
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  //   e.preventDefault();

  
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FormMiddleBoxWrap>
          <RowWrap>
            <Col12Wrap>
            <ToastContainer />
              <Box sx={{ maxWidth: "400px", margin: "auto" }}>
                <FormGroupWrap>
                <InputField
                    type="password"
                    name="newPassword"
                    placeholder="New Password"
                    value={newPassword} // Bind the value to the state
                    onChange={(e) => setNewPassword(e.target.value)} // Update state
                    errorMessage={error}
                    register={()=>{}} // Display error
                />
                </FormGroupWrap>
                <FormGroupWrap>
                <InputField
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={confirmPassword} // Bind the value to the state
                    onChange={(e) => setConfirmPassword(e.target.value)} // Update state
                    errorMessage={error} 
                    register={()=>{}}// Display error
                />
                </FormGroupWrap>
                <FormGroupWrap>
                  <CustomBtn
                    type="submit"
                    variant="outlined"
                    disabled={loading}
                  >
                    {loading ? "Resetting..." : "Reset Password"}
                  </CustomBtn>
                </FormGroupWrap>
                <FormGroupWrap sx={{ marginBottom: "0", textAlign: 'center' }}>
                    <CustomLink to="/">Sign in</CustomLink>
                </FormGroupWrap>
              </Box>
            </Col12Wrap>
          </RowWrap>
        </FormMiddleBoxWrap>
      </form>

      
    </>
  );
};

export default ResetPasswordForm;

const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  borderRadius: "0px 0px 7px 7px",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "20px",
  position: "relative",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 20px",
  boxShadow: "none !important",
}));
const CustomLink = styled(Link)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#2C2C2E",
  textDecoration: "none",
  "&:hover": {
    color: "#1085AB",
  textDecoration: "underline",
  }
}));
